import { render, staticRenderFns } from "./TodoBoard.vue?vue&type=template&id=668602aa&scoped=true"
import script from "./TodoBoard.vue?vue&type=script&lang=js"
export * from "./TodoBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668602aa",
  null
  
)

export default component.exports